module.exports = __webpack_public_path__ + "static/img/diffuse_pigment-01.b0199af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/diffuse_pigment-01.jpg
// module id = 260
// module chunks = 1